/**
 * Get group title for lesson grouping
 */
export const getLessonGroupTitle = (groupKey: string, t: any) => {
  switch (groupKey) {
    case "today":
      return t("common:today", "Today");
    case "tomorrow":
      return t("common:tomorrow", "Tomorrow");
    case "thisWeek":
      return t("common:laterThisWeek", "Later This Week");
    case "nextWeek":
      return t("common:nextWeek", "Next Week");
    case "future":
      return t("common:future", "Future");
    case "yesterday":
      return t("common:yesterday", "Yesterday");
    case "lastWeek":
      return t("common:lastWeek", "Last Week");
    case "lastMonth":
      return t("common:lastMonth", "Last Month");
    case "older":
      return t("common:older", "Older");
    default:
      return groupKey;
  }
};
